module.exports = __webpack_public_path__ + "9e3f788cab8c3144492b236c4a7b48ec.svg";